import { useContext } from 'react';
import { Grid, Button, TextField, MenuItem } from '@mui/material';
import { MdSearch as SearchIcon } from 'react-icons/md';
import { customerTicketsContext } from '../../CustomerTicketsContext';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { FilterContainer } from 'components';


let Filters = () => {
    let { formatMessage } = useIntl();
    let service = useContext(customerTicketsContext);

    return (
        <FilterContainer onSubmit={() => service.doSearch(service.search)}>
            <Grid item xs={4} md={2}>
                <TextField
                    variant="standard"
                    label={formatMessage({ id: LocalizationIds.Search })}
                    value={service.search.searchText}
                    onChange={(e) => service.updateSearch({
                        ...service.search,
                        searchText: e.target.value
                    })}
                />
            </Grid>
            <Grid item xs={4} md={2}>
                <TextField
                    select
                    variant="standard"
                    name="filter"
                    label={formatMessage({ id: LocalizationIds.Filter })}
                    value={service.search.filter}
                    onChange={(e) => {
                        let request = {
                            ...service.search,
                            filter: e.target.value
                        }

                        service.updateSearch(request);
                        service.doSearch(request);
                    }}
                >
                    <MenuItem value="All">{formatMessage({ id: LocalizationIds.All })}</MenuItem>
                    <MenuItem value="Open">{formatMessage({ id: LocalizationIds.Open })}</MenuItem>
                    <MenuItem value="Closed">{formatMessage({ id: LocalizationIds.Closed })}</MenuItem>
                </TextField>
            </Grid>
            <Grid item xs={2} md={1}>
                <Button
                    type="submit"
                    color="secondary"
                    variant="outlined"
                    aria-label="search"
                >
                    <SearchIcon />
                </Button>
            </Grid>
            <Grid item xs />
        </FilterContainer>
    );
}

export default Filters;